import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FORMAT_STYLES } from "@/lib/brand";

export const DayDialog = ({ day, onClose }) => {
  const s = FORMAT_STYLES[day?.format] || FORMAT_STYLES.Post;
  return (
    <Dialog open={!!day} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="day-dialog" className="rounded-3xl border-0 p-0 overflow-hidden max-w-lg">
        {day && (
          <>
            <div className="p-6" style={{ background: s.bg, color: s.fg }}>
              <DialogHeader>
                <p className="text-xs uppercase tracking-[0.25em] font-bold">Day {day.day} · {day.format} · {day.pillar}</p>
                <DialogTitle data-testid="day-dialog-title" className="text-3xl font-extrabold tracking-tight">{day.title}</DialogTitle>
                <DialogDescription className="sr-only">Content idea details</DialogDescription>
              </DialogHeader>
            </div>
            <div className="p-6 space-y-5 bg-white">
              <Block label="What to post" text={day.idea} />
              <Block label="Hook / caption starter" text={`"${day.hook}"`} hand />
              <Block label="Pro tip" text={day.tip} />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

const Block = ({ label, text, hand }) => (
  <div>
    <p className="text-xs uppercase tracking-[0.2em] text-[var(--muted)] mb-1">{label}</p>
    <p className={hand ? "font-hand text-2xl text-[var(--green-2)]" : "text-base"}>{text}</p>
  </div>
);
